var lists_default = {
  "fontElementMap": "Nl8ty",
  "orderedlist": "NZ0mD",
  "bulletedlist": "MFFaW",
  "listItem": "ao-rG"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
